export interface WipOrder {
	customerOrderNumber: string;
	customerOrderItemNumber: string;
	supplierOrderNumber: string;
	supplierOrderItemNumber: string;
	statusWorkInProgress: string;
	statusWorkInProgressDescription: string;
	qtyWorkInProgress: number;
	forecastInStock: string;
}

export type FieldOfWipOrder = keyof WipOrder;

export interface WipOrderResult {
	results: WipOrder[];
}

export const wipOrderFields = <const> [
	'customerOrderNumber',
	'customerOrderItemNumber',
	'supplierOrderNumber',
	'supplierOrderItemNumber',
	'statusWorkInProgress',
	'qtyWorkInProgress',
	'forecastInStock'
];
